import { fetchHTML } from '@utils';
import { pubsub } from '@services';

class CartItemCount extends HTMLElement {
  connectedCallback() {
    this.unsubscribeCartAdded = pubsub.subscribe('cart:added', () => this.addCartCount());
    this.unsubscribeCartUpdated = pubsub.subscribe('cart:updated', () => this.addCartCount());
  }

  disconnectedCallback() {
    this.unsubscribeCartAdded();
    this.unsubscribeCartUpdated();
  }

  /**
   * Add cart count
   */
  async addCartCount() {
    try {
      const html = await fetchHTML(`${Shopify.routes.root}?section_id=fetch-cart-item-count`);
      const target = html.querySelector('cart-item-count');
      this.replaceWith(target);
    } catch (error) {
      console.log(error.message);
    }
  }
}

customElements.define('cart-item-count', CartItemCount);
